import FSCss from "../../css/overview.module.css";
import editcss from "../../../myfin_v2/css/editTranslation.module.css";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as DropdownIcon } from "../../../myfin_v2/assets/icons/down-arrow.svg";
import { ReactComponent as CalendarIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as GreenDot } from "../../assets/icons/greenDotSmall.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as BackArrow } from "../../assets/icons/left_arrow.svg";
import commoncss from "../../css/common.module.css";
import { toast } from "react-toastify";
// import { getMappingDetails } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { retranslateConsolApiHandler, getConsolMappingDetailsApiHandler, fetchInvestmentRegisters } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Breadcrumb from "../Breadcrumb";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";
import Modal from "../../../myfin_v2/elements/Modal";

const FSTopBar = ({ 
  history, 
  consolID, 
  prepopulate = false, 
  activeCat,
  workspaceName = "Workspace",
  consolName = "Consol",
  workspaceID = "",
  showCashflowWorkings = false,
  onToggleCashflowWorkings = () => {},
  showAdjustmentLog = false,
  onOpenAdjustmentLog = () => {},
  showAddAdjustment = false,
  onAddAdjustment = () => {},
}) => {
  const [editTranslation, setEditTranslation] = useState(false);
  const [hasTranslatedFS, setHasTranslatedFS] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);
  const [functionalCurrency, setFunctionalCurrency] = useState("");
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [previousFinancialYear, setPreviousFinancialYear] = useState("");
  const [translationData, setTranslationData] = useState({
    reportingCurrency: "",
    currentYearOpeningRate: "",
    currentYearClosingRate: "",
    currentYearAverageRate: "",
    previousYearOpeningRate: "",
    previousYearClosingRate: "",
    previousYearAverageRate: "",
  });

  const [presetName, setPresetName] = useState("");
  const [investmentRegister, setInvestmentRegister] = useState(null);
  const [fillCurrency, setFillCurrency] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [natureOfCompany, setNatureOfCompany] = useState("");
  const [nameOfFinancials, setNameOfFinancials] = useState("");
  const [selectGAAP, setSelectGAAP] = useState("");
  const [presetsCOA, setPresetsCOA] = useState("");
  const [allInvestmentRegisters, setAllInvestmentRegisters] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorData, setErrorData] = useState(null);
  const [showConfigureModal, setShowConfigureModal] = useState(false);

  useEffect(() => {
    const getInvestmentRegisters = async () => {
      try {
        const res = await fetchInvestmentRegisters();
        if (res?.data?.success) {
          const formattedInvestments = res.data.investmentList.map((inv) => ({
            label: inv.name,
            value: inv._id
          }));
          setAllInvestmentRegisters(formattedInvestments);
        }
      } catch (error) {
        console.log("Error fetching investments", error);
      }
    };
    getInvestmentRegisters();
  }, []);

  useEffect(() => {
    if (consolID) {
      fetchMappingDetails();
    }
  }, [consolID]);

  const fetchMappingDetails = async () => {
    try {
      const res = await getConsolMappingDetailsApiHandler({ consolID });
      if (res?.data?.success) {
        const data = res.data;
        if ((data.translateFS && Object.keys(data.translateFS).length > 0) || data.reportingCurrency) {
          setHasTranslatedFS(true);
        } else {
          setHasTranslatedFS(false);
        }
      }
    } catch (error) {
      console.log("Mapping API error:", error);
    }
  };

 const handleOpenEditTranslation = async () => {
  try {
    setEditTranslation(true);

    console.log("Calling API with consolID:", consolID);

    const res = await getConsolMappingDetailsApiHandler({ consolID });

    console.log("API RESPONSE 👉", res.data);

    const data = res?.data;

    if (data?.success) {

      setFunctionalCurrency(data.functionalCurrency || data.reportingCurrency || "");

      setCurrentFinancialYear(data.currentYear || "");
      setPreviousFinancialYear(data.previousYear || "");

      setPresetName(data.standaloneName || data.presetName || data.standaloneData?.project_name || data.standaloneData?.name || "");
      setCompanyName(data.parentCompanyData?.company_name || data.parentCompanyName || data.companyName || "");
      setNatureOfCompany(data.parentCompanyData?.nature_of_company || data.natureOfCompany || "");
      setNameOfFinancials(data.name || data.consolName || "");
      setSelectGAAP(data.GAAP || data.selectGAAP || data.gaap || "Indian GAAP");
      setPresetsCOA(data.presetsCOA || data.selectCOA || data.standaloneName || data.presetName || data.standaloneData?.project_name || "");

      setTranslationData({
        reportingCurrency: data.reportingCurrency || "",
        currentYearOpeningRate: data.translateFS?.currentYearOpeningRate || "",
        currentYearClosingRate: data.translateFS?.currentYearClosingRate || "",
        currentYearAverageRate: data.translateFS?.currentYearAverageRate || "",
        previousYearOpeningRate: data.translateFS?.previousYearOpeningRate || "",
        previousYearClosingRate: data.translateFS?.previousYearClosingRate || "",
        previousYearAverageRate: data.translateFS?.previousYearAverageRate || "",
      });
    }
  } catch (error) {
    console.error("API ERROR ❌", error);
    setErrorData({
      title: "Error",
      message: "Failed to load translation data"
    });
  }
};

  const handleSelectCurrency = (value) => {
    setTranslationData((prev) => ({ ...prev, reportingCurrency: value }));
    setOpenCurrency(false);
  };

  const handleTranslationChange = (e) => {
    const { name, value } = e.target;
    setTranslationData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveTranslation = async () => {
    try {
      const body = {
        reportingCurrency: translationData.reportingCurrency,
        // investmentID: investmentRegister?.value,
        translateFS: {
          currentYearOpeningRate: Number(translationData.currentYearOpeningRate),
          currentYearClosingRate: Number(translationData.currentYearClosingRate),
          currentYearAverageRate: Number(translationData.currentYearAverageRate),
          previousYearOpeningRate: Number(translationData.previousYearOpeningRate),
          previousYearClosingRate: Number(translationData.previousYearClosingRate),
          previousYearAverageRate: Number(translationData.previousYearAverageRate),
        },
      };
      await retranslateConsolApiHandler({ consolID }, body);
      setSuccessMessage("Translation updated successfully");
      setShowSuccessPopup(true);
    } catch (error) {
      setErrorData({
        title: "Error",
        message: "Something went wrong"
      });
    }
  };

  const catLabelMap = {
    BS: "Balance Sheet",
    PL: "P&L Statement",
    "general notes": "General Notes",
    cashflow: "Cashflow",
    socie: "SOCIE",
    "BS notes": "Balance Sheet Notes",
    "PL notes": "P&L Statement Notes",
    Adjustments: "Adjustments",
    disclosure: "Disclosures",
    checklist: "Disclosures Checklist",
  };

  const activeCatLabel = prepopulate && activeCat ? catLabelMap[activeCat] || activeCat : null;

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`,
      className: "nav_cnt_color clickable",
    },
    {
      label: consolName,
      link: "",
      className: "nav_cnt_color",
    },
    ...(activeCatLabel
      ? [{ label: activeCatLabel, link: "", className: "headerLable" }]
      : []),
  ];

  const layoutLeft = ["disclosure", "checklist"].includes(activeCat) ? 25 : 20;
  const layoutRight = activeCat === "checklist" ? 25 : 10;

  return (
    <>
      <ErrorPopup
        isOpen={errorData !== null}
        title={errorData?.title}
        message={errorData?.message}
        onClose={() => setErrorData(null)}
      />
      <SuccessPopup
        isOpen={showSuccessPopup}
        message={successMessage}
        onClose={() => {
          setShowSuccessPopup(false);
          setEditTranslation(false);
        }}
      />
      <div 
        className={FSCss.w100} 
        style={{ 
          paddingRight: "0px",
          paddingLeft: `${layoutLeft - 15}px`
        }}
      >
        <div className={FSCss.uploadLoansMainContainer}></div>

      {showCashflowWorkings ? (
        <div 
          className={FSCss.listPageheader}
          style={{ 
            padding: `10px ${layoutRight}px ${["disclosure", "cashflow"].includes(activeCat) ? "5px" : "10px"} 15px`
          }}
        >
          <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center"}}>
            <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
              <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={onToggleCashflowWorkings} />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(workspaceID ? `/consolidation/${workspaceID}` : `/allWorkspace`)}>{workspaceName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(`/consolidation/${workspaceID}`)}>{consolName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={onToggleCashflowWorkings}>Consolidated Financial Statements - Cashflow</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={commoncss.headerLable} style={{ alignContent: "center" }}>Cashflow Workings</div>
          </div>
          <div className={FSCss.headerRightContainer} style={{ gap: "10px" }}>
            {prepopulate ? (
              <Button
                btnColor={buttoncss.primary}
                label="Populate FS"
                style={{ paddingLeft: "20px" }}
                onClick={() => {
                  history.push(`/myfinV2/console-populatefs/${consolID}`);
                }}
              />
            ) : (
              <Button
                btnColor={buttoncss.primary}
                label="Finalise FS"
                onClick={() => {
                  history.push(`/consol/finalize-fs/${consolID}`);
                }}
              />
            )}
          </div>
        </div>
      ) : (
      <div 
        className={FSCss.listPageheader} 
        style={{ 
          padding: `10px ${layoutRight}px ${["disclosure", "cashflow"].includes(activeCat) ? "5px" : "10px"} 15px`
        }}
      >
        <div className={FSCss.headerLeftContainer} style={{ width: "auto", display: "flex", alignItems: "center" }}>
          <Breadcrumb
            addCls="bgTransprent"
            p0={true}
            items={breadcrumbItems}
            headerActions={<></>}
            backLink={workspaceID ? `/consolidation/${workspaceID}` : "/myfinV2/standalonefs"}
          />
        </div>

        <div className={FSCss.headerRightContainer} style={{ gap: "10px" }}>
          {/* {activeCat === "socie" && (
            <Button
              btnColor={buttoncss.secondary}
              style={{ background: "transparent" }}
              label="Configure"
              onClick={() => setShowConfigureModal(true)}
            />
          )} */}
          {/* {activeCat === "cashflow" && (
            <Button
              btnColor={buttoncss.secondary}
              style={{ background: "transparent" }}
              label="Cashflow workings"
              onClick={onToggleCashflowWorkings}
            />
          )} */}

          {/* Edit Translation Button */}
          {hasTranslatedFS && (
            <Button
              btnColor={buttoncss.secondary}
              class_={buttoncss.greyBg}
              label={
                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <EditIcon width={15} height={15} />
                  Edit Translation
                </span>
              }
              onClick={handleOpenEditTranslation}
            />
          )}

          {/* Edit Translation Modal */}
          {editTranslation && ReactDOM.createPortal(
            <div className={editcss.modalOverlay}>
              <div className={editcss.modalContainer}>

                <div className={editcss.modalHeader}>
                  <span className={editcss.modalTitle}>Edit Translation</span>
                  <CloseIcon
                    className="clickable"
                    width={18}
                    height={18}
                    onClick={() => setEditTranslation(false)}
                  />
                </div>

                <div className={editcss.modalBody}>
                  <div className={editcss.field}>
                    <label>Select Preset</label>
                    <div className={editcss.inputWrapper}>
                      <input
                        className={editcss.inputField}
                        placeholder="Preset Name Here"
                        value={presetName}
                        onChange={(e) => setPresetName(e.target.value)}
                      />
                      <DropdownIcon className={editcss.dropdownIcon} />
                    </div>
                  </div>

                  <div className={editcss.field}>
                    <label>Reporting Currency</label>
                    <div className={editcss.dropdownWrapper}>
                      <div className={editcss.inputWrapper}>
                        <input
                          className={editcss.inputField}
                          placeholder="Select Currency"
                          readOnly
                          value={translationData.reportingCurrency}
                          onClick={() => setOpenCurrency(!openCurrency)}
                        />
                        <DropdownIcon className={editcss.dropdownIcon} />
                      </div>
                      {openCurrency && (
                        <div className={editcss.dropdownMenu}>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("INR")}
                          >
                            INR
                          </div>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("USD")}
                          >
                            USD
                          </div>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("CAD")}
                          >
                            CAD
                          </div>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("GBP")}
                          >
                            GBP
                          </div>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("EUR")}
                          >
                            EUR
                          </div>
                          <div
                            className={editcss.dropdownOption}
                            onClick={() => handleSelectCurrency("CHF")}
                          >
                            CHF
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={editcss.field}>
                    <label>Company</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Enter company name"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                  </div>

                  <div className={editcss.field}>
                    <label>Nature Of Company</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Enter nature of company"
                      value={natureOfCompany}
                      onChange={(e) => setNatureOfCompany(e.target.value)}
                    />
                  </div>

                  <div className={editcss.field}>
                    <label>Name Of The Financials</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Financial statement Name"
                      value={nameOfFinancials}
                      onChange={(e) => setNameOfFinancials(e.target.value)}
                    />
                  </div>

                  <div className={editcss.field}>
                    <label>Select The GAAP</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Enter GAAP"
                      value={selectGAAP}
                      onChange={(e) => setSelectGAAP(e.target.value)}
                    />
                  </div>

                  <div className={editcss.field}>
                    <label>Current Financial Year</label>
                    <div className={editcss.inputWrapper}>
                      <input
                        className={editcss.inputField}
                        value={
                          currentFinancialYear
                            ? new Date(currentFinancialYear).toISOString().split("T")[0]
                            : ""
                        }
                        placeholder="DD-MM-YYYY"
                        readOnly
                      />
                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                  </div>

                  <div className={editcss.field}>
                    <label>Previous Financial Year</label>
                    <div className={editcss.inputWrapper}>
                      <input
                        className={editcss.inputField}
                        value={
                          previousFinancialYear
                            ? new Date(previousFinancialYear).toISOString().split("T")[0]
                            : ""
                        }
                        placeholder="DD-MM-YYYY"
                        readOnly
                      />
                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                  </div>

                  <div className={editcss.field}>
                    <label>Select Presets/Chart Of Accounts</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Select Presets/COA"
                      value={presetsCOA}
                      onChange={(e) => setPresetsCOA(e.target.value)}
                    />
                  </div>

                  <div className={editcss.field}>
                    <label>Functional Currency</label>
                    <input
                      className={editcss.inputField}
                      value={functionalCurrency}
                      placeholder="Functional Currency"
                      readOnly
                    />
                  </div>

                  {/* <div className={editcss.field} style={{ gridColumn: "1 / -1" }}>
                    <label>Select Investment Register</label>
                    <Dropdown
                      value={investmentRegister}
                      options={allInvestmentRegisters}
                      onChange={(value) => setInvestmentRegister(value)}
                      placeholder="Select Investment Register for accurate translation of equity balances"
                      className={editcss.inputField}
                    />
                  </div> */}
                </div>

                {/* Translation Rates Table */}
                <div>
                  <div className={editcss.translationSection}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span className={editcss.translationTitle}>
                        Translation information :{" "}
                        <b style={{ color: "#2D8861" }}>
                          {functionalCurrency && translationData.reportingCurrency
                            ? `${functionalCurrency} to ${translationData.reportingCurrency}`
                            : "USD to INR"}
                        </b>
                      </span>
                    </div>

                    <div className={editcss.translationContainer} style={{ marginTop: '10px' }}>
                      <table className={editcss.translationTable}>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>DATE</th>
                            <th style={{ textAlign: "right" }}>OPENING RATE</th>
                            <th style={{ textAlign: "right" }}>CLOSING RATE</th>
                            <th style={{ textAlign: "right" }}>AVERAGE RATE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "left" }}>Current Year</td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="currentYearOpeningRate"
                                value={translationData.currentYearOpeningRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="currentYearClosingRate"
                                value={translationData.currentYearClosingRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="currentYearAverageRate"
                                value={translationData.currentYearAverageRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>Previous Year</td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="previousYearOpeningRate"
                                value={translationData.previousYearOpeningRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="previousYearClosingRate"
                                value={translationData.previousYearClosingRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <input
                                type="number"
                                name="previousYearAverageRate"
                                value={translationData.previousYearAverageRate}
                                onChange={handleTranslationChange}
                                style={{ textAlign: "right" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className={editcss.modalFooter}>
                  <Button
                    btnColor={buttoncss.primary}
                    label="Save Changes"
                    onClick={handleSaveTranslation}
                  />
                </div>

              </div>
            </div>,
            document.body
          )}

          {/* Populate FS / Finalise FS */}
          {prepopulate ? (
            <Button
              btnColor={buttoncss.primary}
              label="Populate FS"
              style={{ paddingLeft: "20px" }}
              onClick={() => {
                history.push(`/myfinV2/console-populatefs/${consolID}`);
              }}
            />
          ) : (
            <Button
              btnColor={buttoncss.primary}
              label="Finalise FS"
              onClick={() => {
                history.push(`/consol/finalize-fs/${consolID}`);
              }}
            />
          )}
        </div>
      </div>
      )}
    </div>

      {showConfigureModal && (
        <Modal
          title="Configure"
          headerActions={
            <CloseIcon 
              style={{ cursor: "pointer", width: 16, height: 16 }} 
              onClick={() => setShowConfigureModal(false)} 
            />
          }
          width="500px"
          bodyStyle={{ background: "#fff", borderRadius: "0 0 10px 10px", padding: "30px 27px" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 1</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 2</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 3</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FSTopBar;






// import FSCss from "../../css/overview.module.css";
// import React, { useState } from "react";
// import { useHistory } from "react-router-dom";
// import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
// import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
// import buttoncss from "../../../myfin_v2/css/button.module.css";
// import { Button } from "../../../myfin_v2/elements/Button";
// import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
// import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";

// const FSTopBar = ({ history, consolID, prepopulate = false }) => {
//   return (
//     <div className={FSCss.w100}  style={{paddingRight: "25px"}} >
//       <div className={FSCss.uploadLoansMainContainer}></div>

//       <div className={FSCss.listPageheader}>
//         <div className={FSCss.headerLeftContainer}>
//           <div className={FSCss.iconContainer}></div>
//         </div>
//         <div className={FSCss.headerRightContainer}>
//           &ensp;
//           {prepopulate ? (
//             <Button
//               btnColor={buttoncss.primary}
//               label="Populate FS"
//               style={{ paddingLeft: "20px" }}
//               onClick={() => {
//                 history.push(`/myfinV2/console-populatefs/${consolID}`);
//               }}
//             />
//           ) : (
//             <Button
//               btnColor={buttoncss.primary}
//               label="Finalise FS"
//               onClick={() => {
//                 history.push(`/consol/finalize-fs/${consolID}`);
//               }}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FSTopBar;
